import { render, staticRenderFns } from "./PickerOrderList.vue?vue&type=template&id=60ba71e2&scoped=true&"
import script from "./PickerOrderList.ts?vue&type=script&lang=ts&"
export * from "./PickerOrderList.ts?vue&type=script&lang=ts&"
import style0 from "./PickerOrderList.vue?vue&type=style&index=0&id=60ba71e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba71e2",
  null
  
)

export default component.exports